<template>
    <div class="layout-content inner-body-block">
        <h1>Документы</h1>
        <div class="documents">
            <nuxt-link v-for="item of documents" :key="item.link" :to="item.link">{{ item.name }}</nuxt-link>
        </div>
    </div>
</template>

<script>

export default {
    head: {
        title: 'Документы - Интернет магазин мебели «ТриЯ»'
    },
    data: () => ({
        documents: [
            {name: 'Политика конфиденциальности', link: 'nda'},
            {name: 'Публичная оферта', link: 'offer'},
        ]
    })
}

</script>

<style lang="scss" scoped>

h1 {
    font-weight: 500;
    text-align: center;
}

.documents {
    a {
        display: block;
        text-decoration: none;
        color: var(--t1);

        font-size: 18px;
        padding: 7px 0;

        &:not(:last-child) {
            border-bottom: 1px solid #ccc;
        }

    }
}

</style>